<template>
  <div id="main-box">
    <div class="page-content" :class="{bottom:list.length > 0}">
      <div class="table-box layui-body" style="left:0;">
        <div class="xblock layui-form">
          <div class="layui-input-inline xblock-row">
            <button class="layui-btn" v-on:click="AddRecord('新增入库',0)"><i class="fa fa-plus"></i> 新增入库</button>
          </div>
          <div class="layui-input-inline xblock-row">
            <button class="layui-btn layui-btn-normal" v-on:click="AddRecord('新增出库',1)"><i class="fa fa-plus"></i> 新增出库</button>
          </div>
          <div class="layui-input-inline country_select xblock-row">
            <select name="status" v-model="current_status" lay-verify="required" lay-filter="status_selection">
              <option value="-1">全部</option>
              <option :value="item.id" v-text="item.name" v-for="(item,index) in status" v-bind:key="index"></option>
            </select>
          </div>
          <div class="layui-input-inline xblock-row">
            <input type="text" name="username" placeholder="编号查询" v-on:keydown.13="get_sotck_record(true)" v-model="variation_id"
              autocomplete="off" class="layui-input" />
          </div>
          <div class="layui-input-inline xblock-row">
            <input type="text" name="username" placeholder="SKU查询" v-on:keydown.13="get_sotck_record(true)" v-model="sku_parent"
              autocomplete="off" class="layui-input" />
          </div>
          <div class="layui-input-inline xblock-row">
            <button class="layui-btn" style="height: 35px;" v-on:click="get_sotck_record(true)"><i
                class="fa fa-search"></i></button>
          </div>
          <span class="x-right xblock-row" v-text="'　共有数据：'+count+ '条'"></span>
          <div class="clear-both"></div>
        </div>

        <div class="table-box-list">
          <table class="layui-table layui-table-margin">
            <thead>
              <tr>
                <th style="width: 80px;">图片</th>
                <th>仓库</th>
                <th>站点</th>
                <th>店铺</th>
                <th>编号</th>
                <th>SKU</th>
                <th>规格</th>
                <th>单号</th>
                <th>库存</th>
                <th>名称</th>
                <th>备注</th>
                <th>时间</th>
              </tr>
            </thead>
            <tbody v-viewer>
              <tr class="order_box" v-for="(item,index) in list" v-bind:key="index">
                <td>
                  <div class="table_img col-img" :style="{'background-image': 'url('+item.variation_info.image+')'}">
                    <img class="viewerimg" :src="item.variation_info.image">
                  </div>
                </td>
                <td>
                  <div style="width: 45px;">
                    <i v-for="val in warehouseList" v-if="item.warehouse == val.id" v-text="val.name"></i>
                  </div>
                </td>
                <td v-text="item.customize_field.country"></td>
                <td v-text="item.customize_field.name"></td>
                <td>
                  <i v-if="item.variation_info.variation_id != 0" v-text="item.variation_info.variation_id"></i>
                  <i v-else>-</i>
                </td>
                <td v-text="item.sku_parent"></td>
                <td v-text="item.variation_info.sku_name"></td>
                <td>
                  <i v-if="item.shipment_number" v-text="item.shipment_number"></i>
                  <i v-else>发货出库</i>
                </td>
                <td>
                  <i class="redColor" v-if="item.e_type == 0" v-text="'+'+item.number"></i>
                  <i class="blueColor" v-else v-text="'-'+item.number"></i>
                </td>
                <td v-text="item.variation_info.name"></td>
                <td class="word-break" v-text="item.remark"></td>
                <td v-text="item.created_at"></td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- transition -->
        <K-Transition :isLoding="isLoding" v-if="isLoding || list.length < 1" style="margin-top: 16px;"></K-Transition>

      </div>

      <!-- 分页 -->
      <div class="page-box"><div id="pagebox" class="pagebox"></div></div>

    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

  </div>
</template>

<script>
  var self, form, layer, laypage,AddStockBox,AddRecordBox,idarr=[];
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  import Confirm from '@/components/common/Confirm.vue'
  export default {
    name: 'Stock',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
      'K-Confirm': Confirm,
    },
    data() {
      return {
        role:null,
        isLoding: false,
        loading: false,
        isload:false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        Confirm: {
          state: false,
          txt: null
        },
        page: 1,
        count: 0,
        total: 0,
        etype:0,
        page_num: 20,
        list: [],
        shop_list:[],
        itemid:null,
        items:[],
        current_status: -1,
        uid:null,
        status: [{
          id: 0,
          name: "入库记录"
        }, {
          id: 1,
          name: "出库记录"
        }],
        variation_id:null,
        sku_parent:null,
        warehouseList:warehouseList
      }
    },
    mounted() {
      self = this;

      if (self.$route.query.id) {
        self.variation_id = self.$route.query.id;
      }

      if (self.$route.query.sku) {
        self.sku_parent = self.$route.query.sku;
      }

      if (self.$route.query.uid) {
        self.uid = self.$route.query.uid;
      }else{
        if(localStorage.getItem("ExShopee_Role") == 10){
          self.uid = 6;
        }else{
          self.uid = localStorage.getItem("ExShopee_id");
        }
      }


      layui.use(['form', 'layer', 'laypage'], function() {
        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;

        //记录状态选择
        form.on('select(status_selection)', function(data) {
          var val = $("select[name=status").val();
          self.current_status = val;
          self.get_sotck_record(true)
        });

        //弹出商品容器
        form.on('submit(AddProduct)', function(data) {
          var w, h;
          if (w == null || w == '') {
            w = $(window).width() - 260;
          };
          if (h == null || h == '') {
            h = $(window).height() - 195;
          };
          AddRecordBox = layer.open({
            type: 1,
            offset: '100px',
            title: "请选择商品",
            area: [w + 'px', h + 'px'],
            fixed: false, //不固定
            content: StockProduct,
            success: function() {
              form.on('submit(sreach)', function(data) {
                self.isload = false;
                self.list = [];
                self.get_product_list();
              });
              form.render();
            }
          });
        });

        //选中商品
        form.on('submit(SelectProduct)', function(data) {
          let id = data.elem.dataset.id;
          for(let x in self.items){
            if(self.items[x].model_id != 0){
              if(id == self.items[x].model_id){
                var datas = self.items[x];
              }
            }else{
              if(id == self.items[x].item_id){
                var datas = self.items[x];
              }
            }
          }

          //重复校验
          if(idarr.length > 0 ){
            for(let i in idarr){
              if(datas.model_id != 0){
                if(idarr[i] == datas.model_id){
                  layer.msg("该货品已经添加！");
                  layer.close(AddRecordBox);
                  return;
                }
              }else{
                if(idarr[i] == datas.item_id){
                  layer.msg("该货品已经添加！");
                  layer.close(AddRecordBox);
                  return;
                }
              }
            }
          }
          if(datas.model_id != 0){
            idarr.push(datas.model_id);
          }else{
            idarr.push(datas.item_id);
          }
          var xhtml = "";
          xhtml += '<tr class="layui-form">'
            xhtml += '<td><div class="table_img"><img src="'+datas.img+'"></div></td>'
            if(datas.model_id != 0){
              xhtml += "<td class='model_id'>"+datas.model_id+"</td>"
            }else{
              xhtml += "<td class='model_id'>"+datas.item_id+"</td>"
            }
            xhtml += "<td>"+datas.item_sku+"</td>"
            xhtml += "<td>"+datas.model_sku+"</td>"
            xhtml += "<td>"+datas.name+"</td>"
            xhtml += '<td><input class="layui-input tracking_number" /></td>'
            xhtml += '<td><input class="layui-input number" /></td>'
            xhtml += '<td><textarea rows="5" class="textareaStyle remark"></textarea></td>'
            xhtml += '<td><button type="button" lay-submit lay-filter="delProduct" data-id="'+datas.model_id+'" class="layui-btn layui-btn-danger">移除</button></td>'
          xhtml += "</tr>"
          $("#table-html").append(xhtml);
          layer.close(AddRecordBox);
        });

        //移除商品
        form.on('submit(delProduct)', function(data) {
          $("#table-html tr").each(function(){
            let id = $(this).find(".model_id").text();
            if(id == data.elem.dataset.id){
              $(this).remove();

              //移除商品
              if(idarr.length > 0 ){
                for(let i in idarr){
                  if(idarr[i] == data.elem.dataset.id){
                    idarr.splice(i,1);
                    return;
                  }
                }
              }

            }
          })
        });

        form.render('select');
        self.GetList();
      });
    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      GetList(ref) {
        self.isLoding = true;
        let param = new URLSearchParams()
        param.append('num', 999)
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/get_shop_list/",
          data:param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          var json = response.data;
          var datas = json.datas;
          if (json.code == 200) {
            self.shop_list = datas.list;
            self.get_sotck_record();
          } else if (json.code == 401) {
            self.GoToPage("/");
          } else {
            self.get_sotck_record();
          }
        }).catch(function(error) {
          self.isLoding = false;
          self.ToastFun(2, error); //弹窗提醒
        })

      },
      get_sotck_record() {
        self.isLoding = true;
        let param = new URLSearchParams()
        param.append('num', self.page_num)
        param.append('etype', self.current_status)
        if(self.variation_id){
          param.append('variation_id', self.variation_id)
        }
        if(self.sku_parent){
          param.append('sku_parent', self.sku_parent)
        }
        if(self.uid){
          param.append('uid', self.uid)
        }

        axios({
          method: 'post',
          url: self.GetServerUrl() + "/user_items_stock_log/?page=" + self.page,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.isLoding = false;

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            if (datas.page) {
              let list = datas.list;
              for(let i in list){
                if(list[i].customize_field){
                  list[i].customize_field = JSON.parse(list[i].customize_field);
                }
              }
              self.list = list;
              self.total = datas.total;
              self.count = datas.page.count;
              self.ShowPage(self, laypage, "get_sotck_record"); //分页
              $('.pagebox').show();
            } else {
              self.list = [];
              self.count = 0; //页数
              $('.pagebox').hide();
            }
          });

        }).catch(function(error) {
          self.isLoding = false;
          console.log(error);
        })
      },
      get_product_list() {
        let sku = $("#sku").val();
        let item_id = $("#item_id").val();
        self.loading = true;
        let param = new URLSearchParams()
        if(item_id){
          param.append('item_id', item_id)
        }
        if(sku){
          param.append('sku', sku)
        }
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/user_items/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.loading = false;

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            var list = datas.list;
            var xhtml = "";
            for (let item in list) {
              if (list[item].product_detail) {
                var datas = JSON.parse(list[item].product_detail);
              }

              //店铺检测
              for(let i in self.shop_list){
                if(list[item].shop_id){
                  if(self.shop_list[i].id == list[item].shop_id){
                    var shop_id = self.shop_list[i].id;
                    var shop_country = self.shop_list[i].country;
                    var shop_name = self.shop_list[i].name;
                    var shop_warehouse = self.shop_list[i].warehouse;
                  }
                }else{
                  if(self.shop_list[i].id == datas.item.shopid){
                    var shop_id = self.shop_list[i].id;
                    var shop_country = self.shop_list[i].country;
                    var shop_name = self.shop_list[i].name;
                    var shop_warehouse = self.shop_list[i].warehouse;
                  }
                }
              }

              if (list[item].item_detail) {
                var items = JSON.parse(list[item].item_detail);
                if(!items.model){
                  if(!self.isload){
                    self.isload = true;
                    self.get_item_info(list[item].item_id);
                  }
                  continue;
                }

                //多sku
                if(items.model.length > 0){
                  for(let y in items.model){

                    var item_id,item_img,item_name,item_sku;
                    if(datas.item){
                      item_id = datas.item.item_id;
                      item_img = datas.item.images[0];
                      item_name = datas.item.name;
                      item_sku = datas.item.item_sku;
                    }else{
                      item_id = datas.item_id;
                      item_img = datas.image.image_url_list[0];
                      item_name = datas.item_name;
                      item_sku = datas.item_sku;
                    }
                    var sku_list = items.model[y].tier_index;
                    for(let m in sku_list){
                      var fix = sku_list[m];
                      if(m == 0){
                        items.model[y].model_sku = items.tier_variation[m].option_list[fix].option;
                        if(items.tier_variation[m].option_list[fix].image){
                          item_img = items.tier_variation[m].option_list[fix].image.image_url;
                        }
                      }else{
                        items.model[y].model_sku += ','+items.tier_variation[m].option_list[fix].option;
                      }
                    }

                    xhtml += "<tr>"
                      xhtml += '<td><div class="table_img"><img src="'+item_img+'"></div></td>'
                      xhtml += "<td>"+shop_country+"</td>"
                      xhtml += "<td>"+shop_name+"</td>"
                      xhtml += "<td>"+items.model[y].model_id+"</td>"
                      xhtml += "<td>"+item_sku+"</td>"
                      xhtml += "<td>"+items.model[y].model_sku+"</td>"
                      xhtml += "<td>"+item_name+"</td>"
                      xhtml += '<td><button type="button" lay-submit lay-filter="SelectProduct" data-id="'+items.model[y].model_id+'" class="layui-btn">选择</button></td>'
                    xhtml += "</tr>"

                    //判断对象是否存在
                    if(self.items.length > 0){
                      for(let z in self.items){
                        if(self.items[z].model_id == items.model[y].model_id){
                          break;
                        }
                        if(z == self.items.length-1){
                          self.items.push({
                            shop_id:shop_id,
                            shop_warehouse:shop_warehouse,
                            shop_country:shop_country,
                            shop_name:shop_name,
                            model_id:items.model[y].model_id,
                            img:item_img,
                            item_id:item_id,
                            item_sku:item_sku,
                            model_sku:items.model[y].model_sku,
                            name:item_name,
                          })
                        }
                      }
                    }else{
                      self.items.push({
                        shop_id:shop_id,
                        shop_warehouse:shop_warehouse,
                        shop_country:shop_country,
                        shop_name:shop_name,
                        model_id:items.model[y].model_id,
                        img:item_img,
                        item_id:item_id,
                        item_sku:item_sku,
                        model_sku:items.model[y].model_sku,
                        name:item_name,
                      })
                    }

                  }
                }else{
                  var item_id,item_img,item_name,item_sku;
                  if(datas.item){
                    item_id = datas.item.item_id;
                    item_img = datas.item.images[0];
                    item_name = datas.item.name;
                    item_sku = datas.item.item_sku;
                  }else{
                    item_id = datas.item_id;
                    item_img = datas.image.image_url_list[0];
                    item_name = datas.item_name;
                    item_sku = datas.item_sku;
                  }
                  xhtml += "<tr>"
                    xhtml += '<td><div class="table_img"><img src="'+item_img+'"></div></td>'
                    xhtml += "<td>"+shop_country+"</td>"
                    xhtml += "<td>"+shop_name+"</td>"
                    xhtml += "<td>"+item_id+"</td>"
                    xhtml += "<td>"+item_sku+"</td>"
                    xhtml += "<td>"+item_sku+"</td>"
                    xhtml += "<td>"+item_name+"</td>"
                    xhtml += '<td><button type="button" lay-submit lay-filter="SelectProduct" data-id="'+item_id+'" class="layui-btn">选择</button></td>'
                  xhtml += "</tr>"

                  //判断对象是否存在
                  if(self.items.length > 0){
                    for(let z in self.items){
                      if(items.model.length > 0){ //多SKU
                        if(self.items[z].model_id == items.model[y].model_id){
                          break;
                        }
                      }else{ //单SKU
                        if(datas.item.item_id == self.items[z].item_id){
                          break;
                        }
                      }
                      if(z == self.items.length-1){
                        self.items.push({
                          shop_id:shop_id,
                          shop_warehouse:shop_warehouse,
                          shop_country:shop_country,
                          shop_name:shop_name,
                          model_id:0,
                          img:item_img,
                          item_id:item_id,
                          item_sku:item_sku,
                          model_sku:item_sku,
                          name:item_name,
                        })
                      }
                    }
                  }else{
                    self.items.push({
                      shop_id:shop_id,
                      shop_warehouse:shop_warehouse,
                      shop_country:shop_country,
                      shop_name:shop_name,
                      model_id:0,
                      img:item_img,
                      item_id:item_id,
                      item_sku:item_sku,
                      model_sku:item_sku,
                      name:item_name,
                    })
                  }

                }

              }

            }
            $("#product-table-html").html(xhtml);
          });

        }).catch(function(error) {
          console.log(error);
          self.loading = false;
        })
      },
      AddRecord(title,etype) {
        var w, h;
        self.etype = etype;
        if (title == null || title == '') {
          title = false;
        };
        if (w == null || w == '') {
          w = $(window).width() - 260;
        };
        if (h == null || h == '') {
          h = $(window).height() - 195;
        };
        AddStockBox = layer.open({
          type: 1,
          offset: '100px',
          title: title,
          area: [w + 'px', h + 'px'],
          fixed: false, //不固定
          btn: ['提交'],
          content: StockRecord,
          success: function() {
            form.render();
          },
          yes: function(index, layero) {
            self.SubmitDatas();
          },
          end: function(){
            idarr = [];
          }
        });
      },
      SubmitDatas() {
        var datas = [];
        $("#table-html tr").each(function(){
          let id = $(this).find(".model_id").text();
          let tracking_number = $(this).find(".tracking_number").val();
          let number = $(this).find(".number").val();
          let remark = $(this).find(".remark").val();

          if(!tracking_number){
            layer.msg("快递单号不能为空！");
            return false;
          }

          if(!number){
            layer.msg("数量不能为空！");
            return false;
          }

          for(let i in self.items){
            console.log(id);
            if(self.items[i].model_id){
              if(self.items[i].model_id  == id){
                datas.push({
                  variation_id:self.items[i].model_id, //变体id
                  shipment_number:tracking_number, //快递单号
                  number:number, //数量
                  remark:remark, //备注
                  name:self.items[i].name, //产品名称
                  image:self.items[i].img, //SKU图片
                  sku_parent:self.items[i].item_sku, //商品SKU
                  items_id:self.items[i].item_id, //产品ID
                  sku_name:self.items[i].model_sku, //SKU名称
                  warehouse: self.items[i].shop_warehouse,
                  customize_field:{id:self.items[i].shop_id,country:self.items[i].shop_country,name:self.items[i].shop_name}, //店铺信息
                })
              }
            }else{
              console.log(self.items[i].item_id);
              if(self.items[i].item_id  == id){
                datas.push({
                  variation_id:self.items[i].model_id, //变体id
                  shipment_number:tracking_number, //快递单号
                  number:number, //数量
                  remark:remark, //备注
                  name:self.items[i].name, //产品名称
                  image:self.items[i].img, //SKU图片
                  sku_parent:self.items[i].item_sku, //商品SKU
                  items_id:self.items[i].item_id, //产品ID
                  sku_name:self.items[i].model_sku, //SKU名称
                  warehouse: self.items[i].shop_warehouse,
                  customize_field:{id:self.items[i].shop_id,country:self.items[i].shop_country,name:self.items[i].shop_name}, //店铺信息
                })
              }
            }

          }
        })

        //内容不匹配阻塞
        if(datas.length != $("#table-html tr").length){
          return;
        }

        self.loading = true;
        let param = new URLSearchParams()
        param.append('etype', self.etype)
        param.append('data', JSON.stringify(datas))
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/user_items_stock_update/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.loading = false;
          var json = response.data;
          var datas = json.datas;
          if (json.code == 200) {
            layer.msg("操作成功！");
            layer.close(AddStockBox);
            self.get_sotck_record();
          } else if (json.code == 401) {
            self.GoToPage("/");
          } else {
            layer.msg(json.msg);
          }
        }).catch(function(error) {
          self.loading = false;
          layer.msg("操作失败！");
        })

      },
      get_item_info (id) {
        self.loading = true;
        let param = new URLSearchParams()
        param.append('item_id', id)
        axios({
          method: 'post',
          url: self.GetServerUrl()+"/reload_item_image_by_item/",
          data:param,
          headers: {'token': localStorage.getItem("ExShopee_token")}
        }).then(function (response) {

          //返回数据处理
          self.ReturnFuntion(self,response,function(datas){
            self.get_product_list();
          });

        }).catch(function (error) {
          self.loading = false;
          console.log(error)
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 18px 15px;
  }
  .country_select {
    width: 150px;
  }
</style>



// WEBPACK FOOTER //
// src/components/logistics/StockRecord.vue